
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import './bootstrap';
import './fontawesome';
import '@fancyapps/fancybox';
// import 'owl.carousel';
import LazyLoad from 'vanilla-lazyload';
import './yupe';
import './prodfilter';
// import './newyear.js';

// eslint-disable-next-line no-new
new LazyLoad({
    container: document,
    elements_selector: '.lazy',
});

const lazyLoadInstances = [];
// eslint-disable-next-line no-new
new LazyLoad({
    elements_selector: '.js-brands-carousel',
    callback_enter: (el) => {
        const oneLL = new LazyLoad({
            container: el,
            elements_selector: '.lazy',
        });
        lazyLoadInstances.push(oneLL);
    },
});
